var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"NavTop"}},[_c('a',{staticClass:"history-report-link is-pulled-right",attrs:{"data-test":"viewHistoryButton"},on:{"click":_vm.toggleHistoryVisibility}},[_c('span',{staticClass:"has-text-white"},[_vm._v("\n      "+_vm._s(_vm.isReportHistoryVisible ?
          _vm.$t('seo_service.nav_top.hide_reports') :
          _vm.$t('seo_service.nav_top.show_reports'))+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }